enum ResourceType {
  LINK = "link",
  FILE = "file",
}
export default ResourceType;
